import client from './client';
import { Driver } from '../types/entities';
import { ApiResponse, CreateDriverRequest } from '../types/api';

export const driverAPI = {
  getAll: async (): Promise<Driver[]> => {
    const response = await client.get('/drivers');
    return response.data.data;
  },

  getById: async (id: number): Promise<Driver> => {
    const response = await client.get(`/drivers/${id}`);
    return response.data.data;
  },

  create: async (data: CreateDriverRequest): Promise<Driver> => {
    const response = await client.post('/drivers', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreateDriverRequest>): Promise<Driver> => {
    const response = await client.put(`/drivers/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/drivers/${id}`);
    return response.data;
  },
};
